var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfocircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 16.5C4.8675 16.5 1.5 13.1325 1.5 9C1.5 4.8675 4.8675 1.5 9 1.5C13.1325 1.5 16.5 4.8675 16.5 9C16.5 13.1325 13.1325 16.5 9 16.5ZM8.4375 12C8.4375 12.3075 8.6925 12.5625 9 12.5625C9.3075 12.5625 9.5625 12.3075 9.5625 12V8.25C9.5625 7.9425 9.3075 7.6875 9 7.6875C8.6925 7.6875 8.4375 7.9425 8.4375 8.25V12ZM9.69 5.715C9.6525 5.6175 9.6 5.5425 9.5325 5.4675C9.4575 5.4 9.375 5.3475 9.285 5.31C9.195 5.2725 9.0975 5.25 9 5.25C8.9025 5.25 8.805 5.2725 8.715 5.31C8.625 5.3475 8.5425 5.4 8.4675 5.4675C8.4 5.5425 8.3475 5.6175 8.31 5.715C8.2725 5.805 8.25 5.9025 8.25 6C8.25 6.0975 8.2725 6.195 8.31 6.285C8.3475 6.375 8.4 6.4575 8.4675 6.5325C8.5425 6.6 8.625 6.6525 8.715 6.69C8.895 6.765 9.105 6.765 9.285 6.69C9.375 6.6525 9.4575 6.6 9.5325 6.5325C9.6 6.4575 9.6525 6.375 9.69 6.285C9.7275 6.195 9.75 6.0975 9.75 6C9.75 5.9025 9.7275 5.805 9.69 5.715Z",
    fill: "#8697B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfocircle);
export default __webpack_public_path__ + "static/media/infocircle.f466c74fb56b133a8f7d25c8a57a9571.svg";
export { ForwardRef as ReactComponent };